import React, { useEffect, useMemo, useState } from "react";
import MasterService from "../services/master/MasterService";

const JenisSatuan = ({idSatuan}) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [uraianSatuan, setUraianSatuan] = useState('')

    useEffect(() => {
        const getSatuan = async () => {
            const response = await masterService.getSatuanByKd(idSatuan)
            setUraianSatuan(response.data.uraianSatuan)
        }
        getSatuan()
    }, [masterService, idSatuan])

    return (
        <>
            {uraianSatuan}
        </>
    )
}

export default JenisSatuan